import { ImportedExclusionsPreviewContentWebComponent } from './component/ImportedExclusionsPreviewContentWebComponent';
import { WEB_COMPONENT_IMPORTED_EXCLUSIONS_PREVIEW } from '../../webcomponents.constants';

export { ImportedExclusionsPreviewContentWebComponent };

window.customElements.define(WEB_COMPONENT_IMPORTED_EXCLUSIONS_PREVIEW, ImportedExclusionsPreviewContentWebComponent);
